// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NXHw","option":"styles_option__2R79i","active":"styles_active__3kiIY"};